import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Footer = () => {
    return (_jsx("div", { className: "fixed bottom-1 right-2 z-30 pointer-events-none select-none", style: {
            fontSize: '10pt',
            color: 'white',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8), -1px -1px 2px rgba(0, 0, 0, 0.8), 1px -1px 2px rgba(0, 0, 0, 0.8), -1px 1px 2px rgba(0, 0, 0, 0.8)',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        }, children: "\u00A9 2026 landscope.earth" }));
};
